import "core-js/modules/es.array.index-of.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/take/bannerDiss.png';
import _imports_1 from '@/assets/images/take/circle.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-361286ce"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "base-info"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "banner",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_3 = {
  key: 0,
  "class": "base-box base-form"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "title"
  }, "请输入你的基本信息", -1);
});
var _hoisted_5 = {
  "class": "form-box"
};
var _hoisted_6 = {
  "class": "qs-item"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "性别", -1);
});
var _hoisted_8 = {
  "class": "qs-item"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "出生日期", -1);
});
var _hoisted_10 = {
  "class": "qs-item"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "身高", -1);
});
var _hoisted_12 = {
  "class": "qs-item"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "qs-title"
  }, "体重", -1);
});
var _hoisted_14 = {
  key: 1,
  "class": "base-box base-result"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "r-title"
  }, "更具效果的减重方式", -1);
});
var _hoisted_16 = {
  "class": "r-content"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, " 在使用GLP-1药物的同时结合生活方式的干预及指导，数千名用户在一年内平均体重减轻 9%-15%，并持续维持18-24个月。 ", -1);
});
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "结合GLP-1助手预计可减掉的体重：", -1);
});
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "推荐您每日能量摄入：", -1);
});
var _hoisted_20 = {
  "class": "blue"
};
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    "class": "banner",
    src: _imports_1,
    alt: ""
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_el_radio = _resolveComponent("el-radio");
  var _component_el_radio_group = _resolveComponent("el-radio-group");
  var _component_el_date_picker = _resolveComponent("el-date-picker");
  var _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, $data.showForm ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
    modelValue: $data.form.sex,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.sex = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: 1
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("男")];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: 2
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode("女")];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_date_picker, {
    modelValue: $data.form.birthday,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.birthday = $event;
    }),
    type: "date",
    placeholder: "请选择出生年-月-日",
    editable: false
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_input, {
    modelValue: $data.form.height,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.height = $event;
    }),
    placeholder: "请输入",
    onInput: _cache[3] || (_cache[3] = function ($event) {
      return $options.numberFn('height');
    })
  }, {
    append: _withCtx(function () {
      return [_createTextVNode("CM")];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_input, {
    modelValue: $data.form.weight,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.weight = $event;
    }),
    placeholder: "请输入",
    onInput: _cache[5] || (_cache[5] = function ($event) {
      return $options.numberFn('weight');
    })
  }, {
    append: _withCtx(function () {
      return [_createTextVNode("KG")];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", {
    "class": "nt-button",
    onClick: _cache[6] || (_cache[6] = function () {
      return $options.submit && $options.submit.apply($options, arguments);
    })
  }, "开始测试")])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", null, [_createTextVNode(" 您的当前体重："), _createElementVNode("b", null, _toDisplayString($data.form.weight) + "KG", 1)]), _createElementVNode("div", null, [_hoisted_18, _createElementVNode("div", {
    "class": _normalizeClass(["blue", $data.result.loseWeight.indexOf('kg') < 0 ? 'r-txt' : ''])
  }, _toDisplayString($data.result.loseWeight), 3)]), _createElementVNode("div", null, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString($data.result.energy), 1)])]), _createElementVNode("div", {
    "class": "nt-button",
    onClick: _cache[7] || (_cache[7] = function ($event) {
      return _this.showForm = true;
    })
  }, "返回")])), _hoisted_21]);
}